import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { ToasterService } from '../../_services/toaster.service';

declare var $: any;
import {environment} from '../../../environments/environment';
import {ScheduleService} from "../../_services/schedule.service";

@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.css']
})
export class ScheduleListComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  eventData: any[] = [];
  id : any;

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute,private toaster: ToasterService, private scheduleservice: ScheduleService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }


    this.id = this.userdetaild['_id'];


    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getDoctorSchedule(this.id);
  }

  getDoctorSchedule(id) {

    this.scheduleservice.getDoctorEvents(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.eventData = data.avilibility;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);

          } else {
            this.toaster.showError('Schedules List', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
        },
        error => {
          this.toaster.showError('Slider List', error);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deleteSchedule(id) {
    const payload = {id: id};
    console.log(payload);
    this.scheduleservice.deleteSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.getDoctorSchedule(this.id);
            this.toaster.showSuccess('Schedule List', data.ResponseMessage);
          } else {
            this.toaster.showError('Schedule List', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Schedule List', error.error.ResponseMessage);
        });
  }


}
